import React, { Fragment } from 'react';
import Styled from 'styled-components';
import Header from './LayoutHeader';
import Footer from './LayoutFooter';

const Content = Styled.section`
  padding-top: 20px;
`;

const PublicLayout = ({ children, ...props }) => (
  <Fragment>
    <Header {...props} />
    <Content>{children}</Content>
    <Footer />
  </Fragment>
);

export default PublicLayout;



// WEBPACK FOOTER //
// ./resources/assets/js/components/Layout/PublicLayout.js